import { Component, OnInit,Input,EventEmitter,Output, ElementRef,Renderer2} from '@angular/core';
import { ApiService } from '../api.service';
import { ObservablesService } from '../observables.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-last-role-users-list',
  templateUrl: './last-role-users-list.component.html',
  styleUrls: ['./last-role-users-list.component.scss']
})
export class LastRoleUsersListComponent implements OnInit {
  @Output() onClientSelected:EventEmitter<any> = new EventEmitter<any>();
  users:any=[]
  treeData:any=[]
  selectedUsers:any=[]
  loggedUserInfo:any=[];
  selectedClient:any;
  clientsList:any=[];
  lastUsersList:any=[];
  totalClientsList:any=[]
  searchTerm:any=''
  isFirstRow:boolean = false
  @Input() set selectedLevelData(selectedLevelData){
    // console.log("input data==",selectedLevelData);
    this.selectedUsers = selectedLevelData;
    this.clientsList = this.selectedUsers;
    this.selectedClient = this.selectedUsers[0];
    // this.onClientSelected.emit(this.selectedUsers[0])
    // this.observables.refreshHeaderPartyStatus.next(this.selectedUsers[0])
  }

  @Input() set selectedData(selectedData){
    // console.log("party  date selected==",selectedData)
    if(selectedData === undefined){
    }else{
      if(selectedData.selectedParty){
        let selected_items:any =this.ele.nativeElement.querySelectorAll('.selected-item');
        if(selected_items.length > 0){

          for(let i=0;i<selected_items.length;i++){
            this.renderer.removeClass(selected_items[i],"selected-item")
          }
        }
      }

    }
  }
  constructor(private api:ApiService,private router:Router, private observables:ObservablesService,private ele:ElementRef,private renderer:Renderer2) { }

    ngOnInit() {
      this.api.getLoggedUserInfo().then((res:any)=>{
        if(res.data.length > 0){
          this.loggedUserInfo = res.data[0];
          // console.log("this.loggedUserInfo=",this.loggedUserInfo)

          this.getUsers()
        }else{
          this.api.logOut()
        }
      })
    }


    getAllRecursiveUsers(data){
      data.filter((item: any,i) =>{

        if(item.children.length > 0 && item.is_last_level == 0){
          this.getAllRecursiveUsers(item.children)
        }else if(item.children.length == 0 && item.is_last_level == 1){
          this.lastUsersList.push(item);
          // console.log("abc",item)
        }
        // if(i == data.length-1 && item.children.length == 0 && item.is_last_level == 1){
        //
        // }
      })
    }

    getAllClients(){
      // this.selectedUsers = this.totalClientsList;
      // this.clientsList = this.lastUsersList;
      this.getUsers()
      this.searchTerm = ''
      this.onClientSelected.emit(undefined)
      this.observables.refreshSelectStatus.next()
      this.observables.resetPartySearchStatus.next()
      let selected_items:any =this.ele.nativeElement.querySelectorAll('.selected-item');
      if(selected_items.length > 0){

        for(let i=0;i<selected_items.length;i++){
          this.renderer.removeClass(selected_items[i],"selected-item")
        }
      }

    }

    getUsers(){
      this.treeData = []
      this.lastUsersList = []
      this.api.send('findDb',{
        table:'users as U',
        fields:['U.id as id','U.full_name','R.role','R.level','R.is_last_level','U.role_id','U.parent_id','U.mobile'],
        joins:[{
          type:"left",
          table:'roles as R',
          conditions:["R.id = U.role_id"]
        }],
        conditions:[{'U.business_id':this.loggedUserInfo.business_id}]
      }).then((result:any)=>{
        this.users=result.data
        // console.log("users=",this.users)

        var idToNodeMap = {};
        var root = null;
        var parentNode;
        for(var i = 0; i < this.users.length; i++) {
            var datum = this.users[i];
            datum.children = [];
            idToNodeMap[datum.id] = datum;

            if(!datum.parent_id) {
                root = datum;
            } else {
                parentNode = idToNodeMap[datum.parent_id];
                parentNode.children.push(datum);
            }
        }

        this.treeData.push(root)

        this.getLoggedUserTreeData(this.treeData,this.loggedUserInfo.level,this.loggedUserInfo.id)
        // console.log("this.dataSource.data=",this.treeData);

      })
    }

    async getLoggedUserTreeData(data,level,id){

      for(let i=0;i<data.length;i++){
        if(data[i].level == level && data[i].id == id){
          if(data[i].children.length > 0){

            await this.getAllRecursiveUsers(data[i].children)
            this.selectedUsers = this.lastUsersList;
            this.clientsList = this.lastUsersList;
            this.totalClientsList = this.selectedUsers
            this.selectedClient = this.lastUsersList[0];
            // this.onClientSelected.emit(this.lastUsersList[0])
            // this.observables.refreshHeaderPartyStatus.next(this.lastUsersList[0])
          }else{
            this.selectedUsers =[]
          }
          break;
        }else{

          if(data[i].children.length > 0 && data[i].is_last_level == 0){
            this.getLoggedUserTreeData(data[i].children,level,id)
          }
        }
        //
        if(i == data.length -1){
          // console.log("final iteration")
          this.selectedUsers = this.lastUsersList;
          this.clientsList = this.lastUsersList;
          this.totalClientsList = this.selectedUsers
          this.selectedClient = this.lastUsersList[0];
          // this.onClientSelected.emit(this.lastUsersList[0])
          // this.observables.refreshHeaderPartyStatus.next(this.lastUsersList[0])
        }
      }
    }

    searchClient(event){

      let searchTerm = event.target.value;

      if(searchTerm.length>0){
        this.selectedUsers = this.clientsList.filter((item)=>{
          return (item.full_name.toLowerCase().indexOf(searchTerm.toLowerCase())> -1);

        });
        // console.log("selectedUsers=",this.selectedUsers)

      }else{
        this.selectedUsers = this.clientsList;

      }
    }

    setData(client,item){
      // console.log('client=')
      let client_items:any =this.ele.nativeElement.querySelectorAll('.client-list');
      let selected_items:any =this.ele.nativeElement.querySelectorAll('.selected-item');
      if(selected_items.length > 0){

        for(let i=0;i<selected_items.length;i++){
          this.renderer.removeClass(selected_items[i],"selected-item")
        }
      }

      let element  = document.querySelectorAll("."+item)[0];
      this.renderer.addClass(element,"selected-item")
      this.selectedClient = client;
      this.onClientSelected.emit(client)
      // this.observables.refreshHeaderPartyStatus.next(client)
    }

}
